<template>
  <v-navigation-drawer
  v-model="drawer"
  fixed
  disable-resize-watcher
  floating
  temporary
  right
  width="800"
  class="aside-class">

    <div class="c-flex-c1 background" style="height: 100%; overflow: hidden;">

      <v-toolbar flat dense color="transparent">

        <v-btn 
        icon
        @click.stop="drawer = !drawer">
          <v-icon
          color="blue-grey darken-3">
            close
          </v-icon>
        </v-btn>

      </v-toolbar>

      <div class="c-hr"></div>

      <iframe v-if="drawer" :src="url" style="flex: 1;"></iframe>
      
      <!-- <trace :id="id" :key="componentKey"></trace> -->

      <!-- <settings v-if="tab === 0"></settings>
      <inv-defs v-if="tab === 1"></inv-defs> -->
      
    </div>
  </v-navigation-drawer>
</template>

<script>
import Settings from '../../views/settings/Settings'
import InventoryDefinitions from '../../views/inventory-definitions/InventoryDefinitionsList'
import Trace from '@/views/trace/ArchiveItem'

export default {
  components: {
    'settings': Settings,
    'inv-defs': InventoryDefinitions,
    Trace
  },
  data () {
    return {
      componentKey: 0,
      tab: 0,
      id: null,
      url: '/dashboard',
      tabs: ['Settings', 'Inventory']
    }
  },
  computed: {
    drawer: {
      get () {
        return this.$store.state.navRight
      },
      set (val) {
        this.$store.commit('openNavRight', val)
      }
    }
  },
  methods: {
    open (url) {
      this.componentKey += 1
      this.url = url
      this.drawer = true
    },
    trace (id) {
      this.id = id
      this.open()
    }
  }
}
</script>

<style scoped>
.aside-class {
  overflow: hidden;
  border-left: thin solid rgba(0,0,0,0.1);
}
.flex.xl2 {
  flex-basis: 100%!important;
  flex-grow: 0!important;
  max-width: 100%!important;
}
</style>
